import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorPage from '@/views/pages/404Page';
import { GuardedPageRoute } from '../routeGuards';
import { SMSMonitorPage } from '../lazyPages';

export const SMSMonitorRoutes = () => {
  const { t } = useTranslation();

  return (
    <Routes>
      <Route
        index
        element={
          <GuardedPageRoute pageName={t('STAFF_SIDEBAR.SMS_MONITOR')}>
            <SMSMonitorPage />
          </GuardedPageRoute>
        }
      />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};
